import { MainContentArea, ContentHeader, Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { DataMappingsList } from "../../components/inputFormats/DataMappingsList";
import { useParams } from "react-router-dom";
import { useInputFormat } from "../../hooks/inputFormats/useInputFormat";
import { useCallback, useState } from "react";
import { DataMappingDrawer } from "../../components/inputFormats/DataMappingDrawer";
import {
  EfsMelcoEfsModelsMappingListItem,
  useGenericDrawer,
} from "melco-shared-logic";

export const DataMappings: React.FC = () => {
  const { t } = useTranslation();

  const { inputFormatId } = useParams<{
    inputFormatId: string;
  }>();

  const { data: inputFormat } = useInputFormat(inputFormatId);

  const breadcrumb = useBreadcrumb("inputFormats", {
    path: `/input-formats/${inputFormatId}`,
    breadcrumbName: inputFormat?.display_name ?? "",
  });

  const dataMappingDrawer = useGenericDrawer();
  const { openDrawer } = dataMappingDrawer;

  const [selectedDataMappingId, setSelectedDataMappingId] = useState<
    string | undefined
  >(undefined);

  const addDataMapping = useCallback(() => {
    setSelectedDataMappingId(undefined);
    openDrawer();
  }, [setSelectedDataMappingId, openDrawer]);

  const editDataMapping = useCallback(
    (dataMapping: EfsMelcoEfsModelsMappingListItem) => {
      const { id } = dataMapping;

      if (id != null) {
        setSelectedDataMappingId(id);
        openDrawer();
      }
    },
    [setSelectedDataMappingId, openDrawer]
  );

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("dataMappings.title")}
          breadcrumb={breadcrumb}
          extra={
            <Button type="primary" icon={<PlusIcon />} onClick={addDataMapping}>
              {t("dataMappings.actions.add.button")}
            </Button>
          }
        />
      }
    >
      {inputFormat && (
        <>
          <DataMappingsList
            inputFormatId={inputFormatId!}
            editDataMapping={editDataMapping}
          />

          <DataMappingDrawer
            key={`data-mapping-drawer-${selectedDataMappingId}`}
            drawer={dataMappingDrawer}
            inputFormat={inputFormat}
            editDataMappingId={selectedDataMappingId}
          />
        </>
      )}
    </MainContentArea>
  );
};
